var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5949 1.91357L4.80392 17.3343C5.12368 17.4968 5.47441 17.5822 5.83011 17.5841H8.36328C8.5752 17.5836 8.77851 17.6714 8.92791 17.8282L10.3007 19.259C11.0452 20.0407 12.0577 20.4807 13.1142 20.4816C13.5504 20.4812 13.9836 20.4066 14.3967 20.2609C15.8211 19.7739 16.8572 18.4862 17.0697 16.9387L19.7682 3.57176C19.897 3.01479 19.8357 2.42846 19.5949 1.91357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8956 0.545947L4.10913 3.35512C1.92437 3.66813 0.396584 5.7689 0.696735 8.0473C0.815291 8.94707 1.21266 9.7818 1.82831 10.4242L3.20033 11.855C3.35029 12.0114 3.43448 12.2235 3.43433 12.4446V15.0864C3.43617 15.4573 3.51807 15.8231 3.67391 16.1566L18.4625 0.731695C17.9765 0.482626 17.4228 0.417001 16.8956 0.545947Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1781,
    height: 20,
    fill: "white",
    transform: "translate(0.657539 0.481445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.1d0b97bf96ccd8c747829cabfaab0a3e.svg";
export { ForwardRef as ReactComponent };